import CardioEcostressList from "./pages/CardioEcostressList.vue";
import CardioEcostressView from "./pages/CardioEcostressView.vue";
import CardioEcostressEdit from "./pages/CardioEcostressEdit.vue";

export default {
    CardioEcostressList,
    CardioEcostressView,
    CardioEcostressEdit,
};
